import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const Path = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { t } = useTranslation("path");

  const handleClick = async (path) => {
    navigate({
      pathname: "/rough",
      search: `?path=${path}`,
    });
  };

  return (
    <div className="h-screen w-screen flex flex-col gap-6 justify-center items-center md-max:p-4">
      <img src="/path-selection.webp" alt="path" className="w-[250px] md-max:w-[150px]" />
      <p className="text-[#141414] font-semibold text-[42px] md-max:text-2xl">{t("greeting")}</p>
      <p className="text-[28px] text-[#141414D9] font-medium md-max:text-xl text-center">
        {t("question")}
        <span className="text-[#3B75DDD9]">{" "}{t("button1")}</span> {t("or")}{" "}
        <span className="text-[#3B75DDD9]">{t("button2")}</span>
      </p>
      <div className="flex items-center gap-5 md-max:gap-2.5">
        <button
          onClick={() => handleClick("professional")}
          className="bg-black rounded-xl text-white border border-black w-[150px] py-5 md-max:py-3 md-max:text-sm cursor-pointer"
        >
          {t("button1")}
        </button>
        <button
          onClick={() => handleClick("student")}
          className="bg-white rounded-xl text-black border border-black w-[150px] py-5 md-max:py-3 md-max:text-sm cursor-pointer"
        >
          {t("button2")}
        </button>
      </div>
      {/* <button
        onClick={() => handleClick("student")}
        className="bg-[#1C75BC] text-white rounded-lg py-[1.5vh] px-[2rem] text-[2vh] font-semibold text-xl begin-button"
        // style={{ display: "none" }}
      >
        Continue as a Student
      </button>
      <button
        onClick={() => handleClick("professional")}
        className="bg-[#1C75BC] text-white rounded-lg py-[1.5vh] px-[2rem] text-[2vh] font-semibold text-xl begin-button"
        // style={{ display: "none" }}
      >
        Continue as a Professional
      </button> */}
    </div>
  );
};

export default Path;
